module.exports = __webpack_public_path__ + "img/linkedin.abb17cdb.svg";